import { mtWatermark } from "@assets/images";
import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 300;
const HEIGHT = 400;

export const MntWatermark = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <img
      src={mtWatermark}
      alt=""
      className={className}
      style={{ ...size, objectFit: "contain", ...style }}
    />
  );
};
